import React from 'react'
import { TabText, StyledTab } from './styles'
import { ThemeColor } from '@/enums'

interface TabNodeProps {
  active?: boolean
  handleClick: (tabKey: string) => void
  tabKey: string
  text: React.ReactNode
  color?: ThemeColor
}

export const TabNode: React.FC<TabNodeProps> = ({
  active,
  handleClick,
  tabKey,
  text,
  color = ThemeColor.b50,
}) => (
  <StyledTab color={color} active={active} onClick={() => handleClick(tabKey)}>
    <TabText>{text}</TabText>
  </StyledTab>
)
